<template>
  <div class="integration-securevue">
    <div class="integration-securevue__login">
      <div class="integration-securevue__title">SecureVUE Login</div>

      <div class="integration-securevue__group">
        <Input
          label="Username"
          name="username"
          :required="true"
          v-model="value.username"
        />
        <Input
          label="Password"
          name="username"
          :required="true"
          :inputType="'password'"
          v-model="value.userPassword"
        />
      </div>
    </div>

    <div class="integration-securevue__employee">
      <div class="integration-securevue__txt">
        <div class="integration-securevue__title">Global Employee</div>
        <div class="integration-securevue__hlp-txt">
          Choose an existing global employee or create a new one.
        </div>
      </div>

      <div class="integration-securevue__group">
        <Dropdown
          :disabled="value.canAddGlobalEmployee"
          label="Global Employee"
          :defaultValue="'Select one'"
          :required="false"
          :options="globalEmployeeOptions"
          v-model="value.employeeId"
        />

        <span class="integration-securevue__employee-action">
          <Button
            ref="addBtn"
            className="btn--has-icon"
            iconClassName="icon-more"
            labelText="Create New"
            :btnClick="addEmployee"
            :iconBeforeLabel="true"
            v-show="!value.canAddGlobalEmployee"
          />
        </span>
      </div>

      <div class="integration-securevue__employee-new">
        <SectionContainer v-if="value.canAddGlobalEmployee">
          <template #left>
            <p>ADD NEW GLOBAL EMPLOYEE</p>
          </template>
          <template #content>
            <div class="integration-securevue__employee-new-content">
              <Input
                className="field__input"
                label="3P Partner"
                name="employeeFirstName"
                v-model="value.employeeFirstName"
                :required="true"
              />
              <Input
                className="field__input"
                label="Integration name"
                name="employeeLastName"
                v-model="value.employeeLastName"
                :required="true"
              />
              <Input
                label="Email"
                inputType="Email"
                name="email"
                placeholder="example@mail.com"
                v-model="value.employeeEmail"
                :required="true"
                @hasError="handleEmailError"
              />
              <span class="integration-securevue__employee-action">
                <Button
                  labelText="Cancel"
                  :btnClick="cleanGlobalEmployee"
                  :iconBeforeLabel="true"
                />
              </span>
            </div>
          </template>
        </SectionContainer>
      </div>
    </div>
  </div>
</template>
<script>
import Input from '@/components/forms/input/input';
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import Button from '@/components/forms/button/button';
import _ from 'lodash';
import SectionContainer from '@/components/shells/section-container/section-container';

export default {
  name: 'IntegrationSecureVue',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Input,
    Dropdown,
    Button,
    SectionContainer,
  },
  data() {
    return {
      globalEmployeeOptions: [
        {
          text: 'test',
          value: 'mytest@dominiondms.com',
        },
      ],
    };
  },
  created() {
    this.checkRequiredFields();
  },
  methods: {
    addEmployee() {
      this.value.employeeId = '';
      this.value.canAddGlobalEmployee = true;
      this.value.employeeFirstName = this.value.vendorName;
      this.value.employeeLastName = this.value.integrationName;
    },
    handleEmailError(obj) {
      this.invalidEmail = obj['email'];
    },
    cleanGlobalEmployee() {
      this.value.employeeFirstName = '';
      this.value.employeeLastName = '';
      this.value.employeeEmail = '';
    },
    requireFieldsAreNotEmpty() {
      const {
        username,
        userPassword,
        employeeId,
        employeeFirstName,
        employeeLastName,
        employeeEmail,
      } = this.value;
      if (_.isEmpty(employeeId)) {
        return !!(
          username &&
          userPassword &&
          employeeFirstName &&
          employeeLastName &&
          !this.invalidEmail &&
          employeeEmail
        );
      }
      return !!(username && userPassword && employeeId);
    },
    sendResult(isReadyToSend) {
      this.$emit('input', this.value);

      if (isReadyToSend) {
        this.$emit('valid', true);
        return;
      }
      this.$emit('valid', false);
    },
    checkRequiredFields() {
      if (this.requireFieldsAreNotEmpty()) {
        this.sendResult(true);
      } else {
        this.sendResult(false);
      }
    },
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.checkRequiredFields();
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.integration-securevue {
  display: flex;
  flex-direction: column;
  gap: $gutter-xl;

  &__group {
    display: grid;
    grid-template-columns: 245px 245px;
    column-gap: $gutter-xxl;
    margin-top: $gutter-lg;
  }

  &__title {
    @include heading('md');
  }
  &__hlp-txt {
    @include sub-heading;
    margin-top: $gutter-md;
  }

  &__employee {
    display: flex;
    flex-direction: column;
  }

  &__employee-new {
    margin-top: $gutter-xl;
  }

  &__employee-action {
    display: flex;
    align-items: flex-end;
  }

  &__employee-new-content {
    display: grid;
    grid-template-columns: 245px 245px;
    align-items: flex-start;
    gap: $gutter-xl;

    @include mq($from: md-l) {
      grid-template-columns: 245px 245px 245px;
      gap: $gutter-xxl;
    }

    @include mq($from: lg) {
      grid-template-columns: 245px 245px 245px auto;
    }

    .integration-securevue__employee-action {
      margin-top: 19px;

      @include mq($from: md-l, $until: lg) {
        margin-top: 0px;
      }
    }
  }
}
</style>
